import { FallbackError } from '../organisms/FallbackError';
import { useTranslation } from 'react-i18next';

const Forbidden = () => {
  const { t } = useTranslation(['random']);
  return <FallbackError errorCode="403" errorText={t('forbidden', { ns: 'random' })} />;
};

export default Forbidden;
export { Forbidden };
